<template>
  <button
    :disabled="disabled"
    class="button"
    :class="[
      `button--${ color } button--${ type }`,
      { 'button--black': black, 'button--nav': nav, 'button--fixed': fixedWidth }
    ]"
    @click="$emit('click')"
  >
    <slot/>
  </button>
</template>

<script>

export default {
  props: {
    color: {
      type: String,
      default: 'light',
      validator: propValue => ['light', 'dark'].includes(propValue)
    },
    type: {
      type: String,
      default: 'normal',
      validator: propValue => ['normal', 'half-left', 'half-right'].includes(propValue)
    },
    black: {
      type: Boolean,
      default: false
    },
    nav: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    @include reset-button;
    @include font($akrobat-font, 900);

    font-size: 12px;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0.5em;
    position: relative;

    padding: 0.625em 1.25em;

    transition: opacity $base-transition;

    &:disabled {
      opacity: .3;
      pointer-events: none;
    }

    &:hover {
      opacity: .85;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -3px;
      border-bottom: 3px solid;
      transition: width $base-transition,
                  left $base-transition;
      will-change: width, left;

      @include media-up(xl) {
        bottom: -5px;
        border-bottom-width: 5px;
      }
    }

    &--normal::after {
      left: 0;
      width: 100%;
    }

    &--normal:hover::after {
      @include media-up(md) {
        width: calc(100% + 2em);
        left: -1em;
      }
    }

    &--half-right,
    &--half-left {
      padding: 1em 1.25em;

      &::after {
        width: 50%;
      }
    }

    &--half-right::after {
      right: 0;
    }

    &--half-left::after {
      left: 0;
    }

    &--light {
      color: $base-text-color;
    }

    &--dark {
      color: $base-opposite-color;
    }

    @include media-up(xl) {
      font-size: 18px;
    }

    &--half-right:hover::after,
    &--half-left:hover::after {
      width: 65%;
    }

    &--black {
      font-weight: 900;
    }

    &--nav {
      padding: 10px 16px;

      @include media-up(xl) {
        padding: 16px 22px;
      }
    }

    &--fixed {
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Button.vue